module.exports = __webpack_public_path__ + "img/2.d9180da4.jpg";